<template>
	<div class="recharge-page  transfer-page page-padding-top">
		<top-bar :title="i18n.t('transfer.title')" @back="back"></top-bar>

		<div class="recharge-main ">
			<div class="flex-center-between account">
				<div class="icon flex-column-center">
					<img :src="arrowUrl1" alt="" class="size1">
					<img :src="arrowUrl2" alt="" class="size2">
					<img :src="arrowUrl3" alt="" class="size3">
				</div>
				<div class="flex-1">
					<div class="flex-center-between transfer-box" @click="changeFromAccount">
						<div>
							<span class="label">{{i18n.t('transfer.label1')}}</span>
						</div>
						<div class="flex-1 flex-center">
							<span class="name flex-1">{{fromAccount.name }}</span>
							<img :src="rightUrl" alt="">
						</div>
					</div>
					<div class="flex-center-between transfer-box" @click="changeAccount">
						<div>
							<span class="label">{{i18n.t('transfer.label2')}}</span>
						</div>
						<div class="flex-1 flex-center line">
							<span class="name flex-1">{{toAccount.name }}</span>
							<img :src="rightUrl" alt="">
						</div>
					</div>
				</div>

				<div class="btn" @click="rechange">
					<img :src="transferUrl" alt="">
				</div>
			</div>

			<!-- <div class="form-label">{{i18n.t('transfer.label3')}}</div> -->

			<!-- <div class="recharge-list">
				<div class="list flex-center" @click="chooseRecharge">
					<div class="icon">
						<img :src="`${bitInfo.icon}`" alt="">
					</div>
					<div class="name flex-1">
						<span>{{bitInfo.ShortName}}</span>
					</div>
					<div class="check">
						<img :src="downUrl" alt="">
					</div>
				</div>
			</div> -->

			<div class="form-label flex-center-between">
				{{i18n.t('transfer.label4')}}
				<div class="flex-center-between desc-line">
					<div>{{i18n.t('transfer.label6')}} </div>
					<div class="count"> {{formatAmountDisplay(userMoney)}} USDT</div>
				</div>
			</div>

			<div class="form-input flex-center-between clear-input" :class="inputActive ? 'active' : ''">
				<input type="number" inputmode="decimal" @focus="inputActive = true"  @blur="inputActive = false" v-model="form.money" :placeholder="i18n.t('transfer.labelPlaceholder')">
				<div class="flex-center adot">
					<span>USDT</span>
					<span class="btn border" @click="setAll">{{i18n.t('transfer.label5')}}</span>
				</div>
			</div>

			<div class="bottom-btn flex-center">
				<Button  class="big" @click="submit">{{i18n.t('transfer.btn')}}</Button>
			</div>
		</div>


     <!--币种-->
    <Popup v-model:show="showRecharge" position="bottom" lock-scroll class="rate-popup">
			<div class="rate-modal">
				<div class="title flex-center-between">
					<div>{{i18n.t('transfer.label7')}}</div>
					<img :src="closeUrl" alt="" @click="cancel">
				</div>
				<div class="recharge-list more">
          <div class="list flex-center" v-for="(item, i) in bitList" :key="i" @click="changeRecharge(i)">
            <div class="icon">
              <img :src="`/upload/${item.Logo}`" alt="">
            </div>
            <div class="name flex-1">
              <span>{{item.ShortName}}</span>
              <span class="desc">{{item.desc}}</span>
            </div>
            <div class="check">
              <img :src="radioUrl" alt="" v-show="i == bitIndex">
            </div>
          </div>
				</div>
				<div class="modal-btn ">
					<Button :disabled="bitIndex === -1" @click="submitChange">{{i18n.t('transfer.btn')}}</Button>
				</div>

			</div>
		</Popup>


		<!--选择账户 到-->
		<Popup v-model:show="showToAccount" position="bottom" lock-scroll class="rate-popup">
			<div class="rate-modal">
				<div class="title flex-center-between">
					<div>{{i18n.t('transfer.label8')}}</div>
					<img :src="closeUrl" alt="" @click="cancel">
				</div>
				<div class="recharge-list ">
          <div class="list flex-center-between" :class="toAccount.name == item.name ? 'active' : ''" v-for="(item, i) in toAccountList" :key="i" @click="chooseAccount(item)">
						<div>{{item.name}}</div>
						
					</div>
				</div>

			</div>
		</Popup>

		<!--选择账户 从-->
		<Popup v-model:show="showFromAccount" position="bottom" lock-scroll class="rate-popup">
			<div class="rate-modal">
				<div class="title flex-center-between">
					<div>{{i18n.t('transfer.label8')}}</div>
					<img :src="closeUrl" alt="" @click="cancel">
				</div>
				<div class="recharge-list ">
          <div class="list big flex-center-between" :class="fromAccount.name == item.name ? 'active' : ''" v-for="(item, i) in fromAccountList" :key="i" @click="chooseFromAccount(item, i)">
						<div>
							<div>{{item.name}}</div>
							<div class="mt-5">{{i18n.t('transfer.label6')}} {{formatAmountDisplay(item.count)}} USDT</div>
						</div>
					</div>
				</div>

			</div>
		</Popup>


	</div>
</template>
<script>
import topBar from '@/components/topBar'
import { Popup, Button } from 'vant'
import {formatNumber, formatAmount} from '@/utils/common'
import { getCoinList } from '@/api/index'
import { wallet, transfer } from '@/api/assest'
export default {
	components: {
    Popup,
    Button,
		topBar
  },
  data() {
		return {
			form: {
				money: ''
			},
			userMoney: 0,
			arrowUrl1: require('../../assets/imgs/icon-arrow1.png'),
			arrowUrl2: require('../../assets/imgs/icon-arrow2.png'),
			arrowUrl3: require('../../assets/imgs/icon-arrow-down3.png'),
			transferUrl: require('../../assets/imgs/icon-transfer4.png'),
			closeUrl: require('../../assets/imgs/icon-close.png'),
			backUrl: require('../../assets/imgs/icon-back.png'),
			rightUrl: require('../../assets/imgs/icon-arrow-right2.png'),
			downUrl: require('../../assets/imgs/icon-arrow-down3.png'),
			logUrl: require('../../assets/imgs/icon-log.png'),
			radioUrl: require('../../assets/imgs/icon-check2.png'),
			checkUrl: require('../../assets/imgs/icon-checked2.png'),
			showRecharge: false,
			inputActive: false,
      bitIndex: 0,
			bitInfo: {},
			accountList: [
				{
					name: this.i18n.t('transfer.account1'),
					key: 'Capital',
					count: 0
				},
				{
					name: this.i18n.t('transfer.account2'),
					key: 'Spot',
					count: 0
				},
				{
					name: this.i18n.t('transfer.account3'),
					key: 'Contract',
					count: 0
				},
				{
					name: this.i18n.t('transfer.account4'),
					key: 'Option',
					count: 0
				},
				{
					name: this.i18n.t('transfer.account5'),
					key: 'Finance',
					count: 0
				},
				{
					name: this.i18n.t('transfer.account6'),
					key: 'Follow',
					count: 0
				},
			],
			fromAccountList: [],
			toAccountList: [],
			fromAccount: {},
			fromIndex: 0,
			toAccount: {},
			showToAccount: false,
			showFromAccount: false,
		}
	},
	computed: {
		bitList() {
      return this.$store.state.bitList
    }
	},
  mounted() {
		let type = this.$route.query.type
		if (type == 1) {// 资产进入划转, 显示资产到期权
			this.fromAccount = this.accountList[0]
			this.toAccount = this.accountList[3]
		} else if (type == 2) {// 期权进入划转, 显示期权到资产
			this.fromIndex = 3
			this.fromAccount = this.accountList[3]
			this.toAccount = this.accountList[0]
		} else if (type == 3) {// 合约进入划转, 显示合约到资产
			this.fromIndex = 2
			this.fromAccount = this.accountList[2]
			this.toAccount = this.accountList[0]
		} else if (type == 4) {// 现货进入划转, 显示现货到资产
			this.fromIndex = 1
			this.fromAccount = this.accountList[1]
			this.toAccount = this.accountList[0]
		} else if (type == 5) {// 金融进入划转, 显示金融到资产
			this.fromIndex = 4
			this.fromAccount = this.accountList[4]
			this.toAccount = this.accountList[0]
		} else if (type == 6) {// 跟单进入划转, 显示跟单到资产
			this.fromIndex = 5
			this.fromAccount = this.accountList[5]
			this.toAccount = this.accountList[0]
		} else {
			this.fromAccount = this.accountList[0]
			this.toAccount = this.accountList[1]
		}
		this.init()
  },
	methods: {
		formatNumber,
		// 格式化金额显示 - 包装utils中的formatAmount函数
		formatAmountDisplay(amount) {
			return formatAmount(amount)
		},
		init() {
			let list = localStorage.getItem('bitList')
      if (list && list != 'undefined' && this.bitList.length == 0) {
        this.$store.state.bitList = JSON.parse(list)
      } 
			if (this.bitList.length == 0) {
        getCoinList().then(res => {
          let bitList = res.data.Items
          this.$store.state.bitList = [].concat(bitList)
					this.getWallet()
        })
      } else {
				this.getWallet()
			}
    },
		getWallet() {
			let form = new FormData()
      form.append('ShortName', 'usdt')
      form.append('current', 1)
      form.append('pageSize', 10)
      wallet(form).then(res => {
				let data = res.data.Items[0]
				if (data) {
					// 验证返回的币种是否为USDT
					if (data.Currency && data.Currency.ShortName.toLowerCase() === 'usdt') {
						// 直接使用返回的Currency对象作为bitInfo
						this.bitInfo = data.Currency
						
						// 直接使用字符串保持原始精度，避免 parseFloat() 精度丢失
						this.accountList[0].count = data.CapitalUse
						this.accountList[1].count = data.SpotUse
						this.accountList[2].count = data.ContractUse
						this.accountList[3].count = data.OptionUse
						this.accountList[4].count = data.FinanceUse
						this.accountList[5].count = data.FollowUse || '0'

						// 使用原始字符串数据，保持最高精度
						this.userMoney = this.accountList[this.fromIndex].count
					} else {
						// 没有找到USDT记录，初始化为0
						console.warn('未找到USDT钱包记录，返回的币种为:', data.Currency ? data.Currency.ShortName : 'unknown')
						this.bitInfo = null
						this.accountList.forEach(account => {
							account.count = '0.00000000'
						})
						this.userMoney = '0.00000000'
					}
				} else {
					// 没有任何记录，初始化为0
					this.bitInfo = null
					this.accountList.forEach(account => {
						account.count = '0.00000000'
					})
					this.userMoney = '0.00000000'
				}
      })
		},
		back() {
			this.$router.go(-1)
		},
		toLog() {
			this.$router.push({
				name: 'assestLog',
				query: {
					type: 'transfer'
				}
			})
		},
		chooseRecharge() {
      this.showRecharge = true
    },
    changeRecharge(i) {
      this.bitIndex = i
    },
		cancel() {
			this.showRecharge = false
			this.showFromAccount = false
			this.showToAccount = false
		},
		submitChange() {
			this.bitInfo = this.bitList[this.bitIndex]
			this.showRecharge = false
			// 转账页面只处理USDT，不需要重新查询钱包
		},
		changeFromAccount() {
			this.showFromAccount = true
			this.fromAccountList = [].concat(this.accountList)

			// this.fromAccountList = this.accountList.filter(v => {
			// 	return v.key != this.toAccount.key
			// })
		},
		changeAccount() {
			this.showToAccount = true
			this.toAccountList = this.accountList.filter(v => {
				return v.key != this.fromAccount.key
			})
		},
		chooseAccount(data) {
			this.toAccount = data
			setTimeout(() => {
				this.showToAccount = false
			}, 100)
		},
		chooseFromAccount(data, i) {
			if (data.key == this.toAccount.key) {
				this.rechange()
			} else {
				this.fromAccount = data
				this.fromIndex = i
				this.userMoney = this.accountList[i].count
			}
			setTimeout(() => {
				this.showFromAccount = false
			}, 100)
		},
		setAll() {
			this.form.money = this.userMoney
		},
		submit() {
			if (!this.form.money) {
				this.$toast.fail(this.i18n.t('transfer.labelPlaceholder'))
				return
			}
			if (this.fromAccount.key == this.toAccount.key) {
				this.$toast.fail(this.i18n.t('transfer.labelPlaceholder2'))
				return
			}

			let form = new FormData()
			form.append('From', this.fromAccount.key)
			form.append('To', this.toAccount.key)
			form.append('Amount', this.form.money)
			form.append('CurrencyId', this.bitInfo.ID)
			transfer(form).then(res => {
				if (res.code == 0) {
					this.$toast.success(this.i18n.t('transfer.success'))
					this.form.money = ''
					// 刷新钱包余额数据
					this.getWallet()
				} else {
					this.$toast.fail(res.msg)
				}
			})
		},
		rechange() {
			let bak = Object.assign({}, this.fromAccount)
			this.fromAccount = Object.assign({}, this.toAccount)
			this.toAccount = bak

			this.userMoney = this.fromAccount.count
		}
	}
}
</script>